import { getStandAloneElement } from 'helpers';

export const getAccessStandAloneToken = () => {
  if (getStandAloneElement() && window.location.hash) {
    return window.location.hash.replace('#', '');
  }
  return '';
};
